import React from 'react';
import { useTranslation } from 'react-i18next';

import icDown from '../../assets/imgs/icDown.svg?react';
import CustomSelect from '../CustomSelect/CustomSelect';
import './style.css';
import styles from './styles.module.css';

type SelectLocationProps = {
    onChangeOriginStop: (value: any) => void;
    onChangeDestStop: (value: any) => void;
    originStop: any;
    destStop: any;
    originStopList: any;
    destStopList: any;
};

function SelectLocation({
    onChangeOriginStop,
    onChangeDestStop,
    originStop,
    destStop,
    originStopList,
    destStopList,
}: SelectLocationProps) {
    const { t } = useTranslation();

    return (
        <div>
            <div className={styles.wrapper}>
                <div className={styles.selectInput}>
                    <div className={styles.label}>{t('reservation.origin-stop')}</div>
                    <CustomSelect
                        value={originStop}
                        variant="plain"
                        listHeight={200}
                        size="large"
                        className={`${styles.selectBtn} select-location`}
                        onChange={onChangeOriginStop}
                        options={originStopList}
                        suffixIcon={<DownOutlined />}
                        placeholder={t('reservation.origin-stop')}
                        getPopupContainer={(trigger: HTMLElement) => trigger.parentNode}
                    />
                </div>
                {/* <div className={styles.arrowDown}>
                    <ArrowDownOutlined className={styles.arrowDownIcon} />
                </div> */}
                <div className={styles.selectInput}>
                    <div className={styles.label}>{t('reservation.dest-stop')}</div>
                    <CustomSelect
                        value={destStop}
                        variant="plain"
                        listHeight={200}
                        size="large"
                        className={`${styles.selectBtn} select-location`}
                        onChange={onChangeDestStop}
                        options={destStopList}
                        suffixIcon={<DownOutlined />}
                        placeholder={t('reservation.dest-stop')}
                        getPopupContainer={(trigger: HTMLElement) => trigger.parentNode}
                    />
                </div>
            </div>
        </div>
    );
}

function DownOutlined() {
    return <div>{React.createElement(icDown, { className: styles.downIcon })}</div>;
}

export default SelectLocation;
